import { type GreetingModel } from '@/shared/api'
import { showDeleteConfirmationModal } from '@/shared/lib/antd-utils'
import { parseDateStringToDayjsDate } from '@/shared/lib/form-utils'
import { COMMON_COLUMN_WIDTH } from '@/shared/lib/styling'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Space, type TableProps } from 'antd'
import { useUnit } from 'effector-react'

import { GreetingConditionTypeEnum } from '../../lib'
import { COLUMN_WIDTH } from '../../lib/column-width'
import { type GreetingsSortState } from '../../lib/greetings-query-model'
import { greetingDeleted } from '../../model/greeting.model'

interface useGreetingsTableColumnsProps {
  onEdit: (greetingId: string) => void
  sort: GreetingsSortState
}
export const useGreetingsTableColumns = ({
  onEdit: handleEdit,
  sort,
}: useGreetingsTableColumnsProps): TableProps<GreetingModel>['columns'] => {
  const deleteGreeting = useUnit(greetingDeleted)
  const handleDelete = (id: string) => {
    showDeleteConfirmationModal({
      onConfirm: () => {
        deleteGreeting({ id })
      },
    })
  }

  return [
    {
      title: 'Наименование',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      ellipsis: true,
      sortOrder:
        sort.field === 'name'
          ? sort.order === 'asc'
            ? 'ascend'
            : sort.order === 'desc'
              ? 'descend'
              : null
          : null,
      render: (name, _) => name,
    },
    {
      title: 'Дата',
      width: COLUMN_WIDTH.DATE,
      dataIndex: 'date',
      key: 'date',
      sorter: true,
      sortOrder:
        sort.field === 'date'
          ? sort.order === 'asc'
            ? 'ascend'
            : sort.order === 'desc'
              ? 'descend'
              : null
          : null,
      render: (_, greeting) =>
        greeting.conditionType === GreetingConditionTypeEnum.EveryDay
          ? 'Ежедневно'
          : greeting.sendOnStartDate
            ? `${parseDateStringToDayjsDate(greeting.sendOnStartDate).format('DD-MM')}${greeting.sendOnEndDate ? ` - ${parseDateStringToDayjsDate(greeting.sendOnEndDate).format('DD-MM')}` : ''}`
            : '',
    },
    {
      title: '',
      width: COMMON_COLUMN_WIDTH.ACTIONS,
      key: 'actions',
      align: 'center',
      render: (_, greeting) => (
        <Space size="middle">
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(greeting.id)}
          />
          <Button
            onClick={() => handleDelete(greeting.id)}
            icon={<DeleteOutlined style={{ color: 'red' }} />}
          />
        </Space>
      ),
    },
  ]
}
